import React, { useState, useEffect } from 'react'
import { Card, Row, Col, Input } from 'reactstrap';
import '../../quoter/styleQuoters/styleGeneralInformations.css'
import '../../quoter/styleQuoterClinicMovil/styleGeneralInformationMobile.css'

export const GeneralInformation = (props) => {

    const {
        name, paternal_surname, maternal_surname, email, phone, observations,
        handleInputChange, viewQuoter, selectedCompany,
        chekTypeClient, validationsSG

    } = props;

    const isMobile = window.innerWidth <= 768;

    const [collapseGeneral, setCollapseGeneral] = useState(() => isMobile);
    useEffect(() => {

        if (
            isMobile &&
            (
                validationsSG?.nameV ||
                validationsSG?.paternal_surnameV ||
                validationsSG?.maternal_surnameV
            )
        ) {

            setCollapseGeneral(false);

            window.scrollTo({
                top:0,
                behavior:"smooth"
            });

        }

    }, [validationsSG]);
    return (
        <>

        <>
            {
                isMobile &&
                chekTypeClient === 3 &&
                selectedCompany && (

                    <div className="company-bar company-bar-mobile">
                        <div className="company-mobile-header">

                            <div className="company-bar-icon">
                                <i className="fa fa-building-o"></i>
                            </div>

                           <div className="company-mobile-info">

                                <div className="company-mobile-label">
                                    Empresa
                                </div>

                                <div className="company-mobile-row">

                                    <div className="company-bar-name">
                                        {selectedCompany?.name_company}
                                    </div>

                                    <div className="company-mobile-contract">
                                        <i className="fa fa-file-text-o"></i>
                                        {selectedCompany?.contract_number}
                                    </div>

                                </div>

                            </div>

                        </div>

                     

                    </div>

                )
            }
        </>

            <div
                className="quoter-general-mobile-header d-md-none"
                onClick={() => setCollapseGeneral(!collapseGeneral)}
            >

             <div className="quoter-general-mobile-title">

                <div className="quoter-general-avatar">
                    <i className="fa fa-user"></i>
                </div>

                <div className="quoter-general-info">

                    <div className="quoter-general-name">
                        {
                            !name && !paternal_surname && !maternal_surname
                                ? "SIN INFORMACIÓN"
                                : [name, paternal_surname, maternal_surname]
                                    .filter(Boolean)
                                    .join(" ")
                        }
                    </div>
                    {/* <div className="quoter-general-subtitle">
                        Información General
                    </div> */}

                    <div className="quoter-general-contact">

                        <span>

                            <i className="fa fa-phone"></i>

                            {phone || "Sin teléfono"}

                        </span>

                        <span>

                            <i className="fa fa-envelope"></i>

                            {email || "Sin correo"}

                        </span>

                    </div>

                </div>

            </div>
            {
                isMobile && (
                    <div
                        className="general-edit-floating"
                        onClick={(e) => {
                            e.stopPropagation();
                            setCollapseGeneral(!collapseGeneral);
                        }}
                    >
                        <i
                            className={
                                collapseGeneral
                                    ? "fa fa-pencil"
                                    : "fa fa-times"
                            }
                        />
                    </div>
                )
            }

            </div>

           
            <Card className={`quoter-card-modern ${viewQuoter ? "general-disabled" : "" }`}>
                <div
                    className={`quoter-collapse ${isMobile && collapseGeneral ? "closed" : ""
                        }`}
                >
                    <div className="quoter-card-content">

                        <Row>

                            <Col xl="2" lg="2" md="4" sm="6" xs="12">
                                <div className="quoter-field">
                                    <label className="quoter-label">
                                        Nombre <span style={{ color: '#ffff'}}>*</span>
                                    </label>

                                    <Input
                                        type="text"
                                        name="name"
                                        value={name}
                                        onChange={handleInputChange}
                                        disabled={viewQuoter}
                                        className={`quoter-input ${
                                            validationsSG?.paternal_surnameV
                                                ? "quoter-input-error"
                                                : ""
                                        }`}
                                        invalid={validationsSG?.nameV}

                                    />

                                    {validationsSG?.nameV && (
                                        <small className="field-error-quoter-clinics">
                                            <i className="fa fa-exclamation-circle"></i>
                                            Campo obligatorio.
                                        </small>
                                    )}
                                
                                </div>
                            </Col>

                            <Col xl="2" lg="2" md="4" sm="6" xs="12">
                                <div className="quoter-field">

                                    <label className="quoter-label">
                                        Apellido paterno
                                    </label>

                                    <input
                                        type="text"
                                        name="paternal_surname"
                                        value={paternal_surname}
                                        onChange={handleInputChange}
                                        className={`quoter-input ${
                                            validationsSG?.paternal_surnameV
                                                ? "quoter-input-error"
                                                : ""
                                        }`}
                                    />

                                    {validationsSG?.paternal_surnameV && (
                                        <small className="field-error-quoter-clinics">
                                            <i className="fa fa-exclamation-circle"></i>
                                            Campo obligatorio.
                                        </small>
                                    )}

                                </div>
                                                            
                            </Col>

                            <Col xl="2" lg="2" md="4" sm="6" xs="12">
                                <div className="quoter-field">
                                    <label className="quoter-label">
                                        Apellido materno <span style={{ color: '#ffff'}}>*</span>
                                    </label>

                                    <Input
                                        type="text"
                                        name="maternal_surname"
                                        value={maternal_surname}
                                        onChange={handleInputChange}
                                        disabled={viewQuoter}
                                        className={`quoter-input ${
                                            validationsSG?.paternal_surnameV
                                                ? "quoter-input-error"
                                                : ""
                                        }`}
                                        invalid={validationsSG?.maternal_surnameV}
                                    />

                                    {validationsSG?.maternal_surnameV && (
                                        <small className="field-error-quoter-clinics">
                                            <i className="fa fa-exclamation-circle"></i>
                                            Campo obligatorio.
                                        </small>
                                    )}
                                </div>
                            </Col>

                            <Col xl="4" lg="4" md="4" sm="6" xs="12">
                                <div className="quoter-field">
                                    <label className="quoter-label">
                                        Correo electrónico
                                    </label>

                                    <Input
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={handleInputChange}
                                        disabled={viewQuoter}
                                        className="quoter-input"
                                    />
                                </div>
                            </Col>

                            <Col xl="2" lg="2" md="4" sm="6" xs="12">
                                <div className="quoter-field">
                                    <label className="quoter-label">
                                        Teléfono
                                    </label>

                                    <Input
                                        type="text"
                                        name="phone"
                                        value={phone}
                                        onChange={handleInputChange}
                                        disabled={viewQuoter}
                                        className="quoter-input"
                                    />
                                </div>
                            </Col>

                            {/* <Col xl="2" lg="2" md="4" sm="12" xs="12">
                            <div className="quoter-field">
                                <label className="quoter-label">
                                    Observaciones
                                </label>

                                <Input
                                    type="textarea"
                                    rows="1"
                                    name="observations"
                                    value={observations}
                                    onChange={handleInputChange}
                                    disabled={viewQuoter}
                                    className="quoter-input quoter-textarea"
                                />
                            </div>
                        </Col> */}

                        </Row>

                    </div>
                </div>


                {
                    chekTypeClient === 3 &&
                    selectedCompany && (

                        
                        <div className="company-bar d-none d-md-flex">

                            <div className="company-bar-icon">
                                <i className="fa fa-building-o"></i>
                            </div>

                            <div className="company-bar-name">
                                {selectedCompany?.name_company}
                            </div>

                            <div className="company-bar-badge">
                                <i className="fa fa-id-card-o"></i>
                                {selectedCompany?.code_company}
                            </div>

                            <div className="company-bar-badge">
                                <i className="fa fa-file-text-o"></i>
                                {selectedCompany?.contract_number}
                            </div>

                            {/* <div className="company-bar-badge">
                        <i className="fa fa-user-o"></i>
                        {selectedCompany?.sales_name}
                    </div> */}

                        </div>
                    )
                }

            </Card>



        </>


    )
}

